import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getContext } from '@fiverr-private/fiverr_context';
import { useInitialProps } from '../useInitialProps';

/**
 * Navigate to the path left off if it exists
 */
export const useRedirectToLeftOff = () => {
    const { pathParameters = {} } = getContext();
    const navigate = useNavigate();
    const { pathLeftOff } = useInitialProps();

    const path = `/${pathParameters.platform}/${pathParameters.step_slug}`;

    useEffect(() => {
        if (pathLeftOff && path !== pathLeftOff) {
            return navigate(pathLeftOff);
        }
    }, [pathLeftOff, navigate, path]);
};
